export type Lang = "oz" | "uz" | "ru";

export const translations: Record<Lang, Record<string, string>> = {
  oz: {
    appName: "Avto Mind",
    todayPractice: "Bugun ham mashq qiling!",
    wrongQuestions: "Xato savollar",
    ticketsSolved: "Biletlar yechildi",
    topicsSolved: "Mavzular yechildi",
    testsByTopics: "Mavzular bo'yicha testlar",
    customTests: "Sozlamali testlar",
    tickets: "Biletlar",
    marathon: "Marafon",
    myWrongQuestions: "Mening xato savollarim",
    signs: "Belgilar",
    controlExam: "Nazorat imtihoni",
    realExam: "Real imtihon",
    profile: "Profil",
    settings: "Sozlamalar",
    logout: "Chiqish",
    user: "Foydalanuvchi",
    fullName: "To'liq ism",
    email: "Email",
    save: "Saqlash",
    language: "Til",
    notifications: "Bildirishnomalar",
    dailyReminder: "Kunlik eslatmalar",

    // oz
    quizMarathonFinished: "Marafon Yakunlandi",
    quizCongrats: "Tabriklaymiz!",
    quizTryAgain: "Qayta urinib ko'ring",
    quizFinishUpper: "YAKUNLASH",
    quizFinish: "Yakunlash",
    quizNext: "Keyingisi",
    quizPrevious: "Oldingi",
    back: "Orqaga",
    randomTest: "Tasodifiy test",
    chooseAmountAndStart: "Miqdorni tanlang va boshlang",
    startRandom: "Tasodifiy boshlash",
    randomInfo:
      "Tanlangan miqdordagi savollar barcha mavzulardan tasodifiy ravishda tanlab olinadi.",
    question: "Savol",
    questionsCount: "{n} ta savol",
    noMistakes: "Zo'r! 🎉",
    noMistakesDesc: "Hozircha xato savollaringiz yo'q!",
    noTypedQuestions: "Hozircha yo'q 🚧",
    noTypedQuestionsDesc:
      "Bu turdagi savollar hali qo'shilmagan. Tez orada paydo bo'ladi!",
    backToMenu: "Menyuga qaytish",
    readiness: "Imtihonga tayyorlik",
    readyForExam: "🎉 Imtihonga tayyor!",
    keepGoing: "💪 Yaxshi ketayapti, davom eting!",
    practiceMore: "📚 Ko'proq mashq qiling!",
    telegramChannel: "Telegram",
    feedback: "Taklif va shikoyatlar",
    trafficRules: "Yo'l harakati qoidalari kitobi (PDF)",
    badgeTop: "TOP",
    badgeNew: "YANGI",
    badgeSoon: "TEZ ORADA",
    catTests: "Nazariy testlar",
    catTestsSub: "Real imtihon, biletlar, mavzular",
    catGames: "O'yinlar",
    catGamesSub: "Marafon, Time Attack, Duel",
    catKnowledge: "Nazariy bilimlar",
    catKnowledgeSub: "Belgilar va yo'l qoidalari",
    catShpargalka: "Shpargalka",
    catShpargalkaSub: "Tezliklar, masofalar, o'lchamlar",
    catSchools: "O'quv joylar",
    catSchoolsSub: "Yandex xaritada avtomaktablar",
    catAI: "Ustoz AI",
    catAISub: "Sun'iy intellekt yordamchi",
    catContacts: "Aloqa va kanallar",
    catContactsSub: "Telegram, taklif, shikoyatlar",
    catTeachers: "Ustozlar",
    catTeachersSub: "Tajribali murabbiylar",
    navHome: "Bosh sahifa",
    navTopicsShort: "Mavzular",
    sectionTests: "Testlar",
    sectionLearn: "O'rganish",
    sectionCommunity: "Hamjamiyat",
    numberTests: "Sonli testlar",
    numberTestsSub: "Savollar soni bilan",
    complexTests: "Murakkab testlar",
    complexTestsSub: "Qiyin savollar to'plami",
    savedTests: "Saqlangan testlar",
    savedTestsSub: "Keyinroq yechish uchun",
    explainedTests: "Izohli testlar",
    explainedTestsSub: "Har bir savolga audio izoh — xatolaringizni tushunib yeching",
    tryIt: "Sinab ko'rish",
    adminPanel: "Admin panel",
    myGroups: "Guruhlarim",
    myGroupsSub: "O'quvchilarni boshqarish",
    controlExamShort: "Nazorat",
    testsByTopicsShort: "Mavzular",
    myWrongQuestionsShort: "Xatolarim",
    catKnowledgeShort: "Bilimlar",
    catVideosShort: "Darsliklar",
    customTestsShort: "Sozlamali",
    numberTestsShort: "Sonli",
    complexTestsShort: "Murakkab",
    savedTestsShort: "Saqlangan",
    testsSubtitle: "Bilimingizni sinab ko'ring",
    realExamSub: "Imtihondagi formatda",
    nazoratSub: "Nazorat imtihoni rejimi",
    topicsSub: "Mavzular bo'yicha",
    customSub: "O'zingiz sozlang",
    ticketsSub: "Bilet variantlari",
    mistakesSub: "Xato javob bergan savollar",
    gamesSubtitle: "Qiziqarli rejimlarda mashq qiling",
    marathonSub: "Cheksiz savollar, 3 ta hayot",
    timeAttackSub: "Vaqtga qarshi yarish",
    duelSub: "Real raqib bilan kurash",
    signsSub: "Yo'l harakati belgilari",
    pdfBook: "PDF kitob",
    login: "Kirish",
    register: "Ro'yxatdan o'tish",
    authSubtitle: "Haydovchilik imtihoniga tayyorlanish",
    authRegisterSubtitle: "Yangi hisob yarating",
    namePlaceholder: "Ismingiz",
    emailOrUsername: "Email yoki Username",
    password: "Parol",
    confirmPassword: "Parolni tasdiqlang",
    loadingText: "Yuklanmoqda...",
    or: "yoki",
    googleLogin: "Google bilan kirish",
    noAccount: "Hisobingiz yo'qmi?",
    hasAccount: "Hisobingiz bormi?",
    passwordMismatch: "Parollar mos kelmadi!",
    errorOccurred: "Xatolik yuz berdi",
    friendDuelPlay: "Do'st bilan o'ynash",
    friendDuelSub: "Do'stingizni chaqiring va bellashing",
    loading: "Yuklanmoqda...",
    cancel: "Bekor qilish",
    notificationsPageTitle: "Bildirishnomalar",
    videosPageTitle: "Amaliyot darsliklari",
    catVideos: "Amaliyot darsliklari",
    catVideosSub: "Video darsliklar orqali mashq qiling",
    noNotifications: "Hozircha bildirishnomalar yo'q",
    noVideos: "Hozircha videolar yo'q",
    reportQuestion: "Savol bo'yicha shikoyat",
    reportWrongAnswer: "Test javobi xato",
    reportTypo: "Imloviy xato",
    reportComment: "Izoh",
    reportCommentPlaceholder: "Fikringizni yozing (ixtiyoriy)...",
    reportSubmit: "Yuborish",
    reportSuccess: "Shikoyatingiz qabul qilindi",
    reportError: "Shikoyat yuborishda xatolik",
    reportSelectType: "Kamida bitta turni tanlang",
    statistics: "Statistika",
    recentTests: "So'nggi testlar",
    totalTests: "Jami test",
    avgScore: "O'rtacha ball",
    correctAnswers: "To'g'ri javob",
    wrongAnswers: "Xato javob",
    favoritesCount: "Sevimlilar",
    duelStats: "Duel statistikasi",
    wins: "G'alaba",
    losses: "Mag'lubiyat",
    draws: "Durang",
    totalGames: "Jami o'yin",
    dangerZone: "Xavfli zona",
    clearHistory: "Tarixni tozalash",
    clearHistoryDesc:
      "Butun test tarixingiz va statistikangiz o'chiriladi. Bu amalni bekor qilib bo'lmaydi.",
    clearHistoryConfirm:
      "Butun test tarixingiz va statistikangiz o'chiriladi. Bu amalni bekor qilib bo'lmaydi. Davom etasizmi?",
    clearHistorySuccess: "Tarix muvaffaqiyatli tozalandi",
  },

  uz: {
    readiness: "Имтиҳонга тайёрлик",
    readyForExam: "🎉 Имтиҳонга тайёр!",
    keepGoing: "💪 Яхши кетаяпти, давом этинг!",
    practiceMore: "📚 Кўпроқ машқ қилинг!",
    noMistakes: "Зўр! 🎉",
    noMistakesDesc: "Ҳозирча хато саволларингиз йўқ!",
    noTypedQuestions: "Ҳозирча йўқ 🚧",
    noTypedQuestionsDesc:
      "Бу турдаги саволлар ҳали қўшилмаган. Тез орада пайдо бўлади!",
    backToMenu: "Менюга қайтиш",
    questionsCount: "{n} та савол",
    appName: "Avto Mind",
    todayPractice: "Бугун ҳам машқ қилинг!",
    wrongQuestions: "Хато саволлар",
    ticketsSolved: "Билетлар ечилди",
    topicsSolved: "Мавзулар ечилди",
    profile: "Профил",
    fullName: "Тўлиқ исм",
    email: "Email",
    save: "Сақлаш",
    language: "Тил",
    notifications: "Билдиришномалар",
    dailyReminder: "Кунлик эслатмалар",
    testsByTopics: "Мавзулар бўйича тестлар",
    customTests: "Созламали тестлар",
    tickets: "Билетлар",
    marathon: "Марафон",
    myWrongQuestions: "Менинг хато саволларим",
    signs: "Белгилар",
    controlExam: "Назорат имтиҳони",
    realExam: "Реал имтиҳон",
    settings: "Созламалар",
    logout: "Чиқиш",
    user: "Фойдаланувчи",
    question: "Савол",
    // uz
    quizMarathonFinished: "Марафон якунланди",
    quizCongrats: "Табриклаймиз!",
    quizTryAgain: "Қайта уриниб кўринг",
    quizFinishUpper: "ЯКУНЛАШ",
    quizFinish: "Якунлаш",
    quizNext: "Кейингиси",
    quizPrevious: "Олдинги",
    back: "Орқага",
    randomTest: "Тасодифий тест",
    chooseAmountAndStart: "Миқдорни танланг ва бошланг",
    startRandom: "Тасодифий бошлаш",
    randomInfo:
      "Танланган миқдордаги саволлар барча мавзулардан тасодифий равишда танлаб олинади.",
    telegramChannel: "Телеграм",
    feedback: "Таклиф ва шикоятлар",
    trafficRules: "Йўл ҳаракати қоидалари китоби (PDF)",
    badgeTop: "TOP",
    badgeNew: "ЯНГИ",
    badgeSoon: "ТЕЗ ОРАДА",
    catTests: "Назарий тестлар",
    catTestsSub: "Реал имтиҳон, билетлар, мавзулар",
    catGames: "Ўйинлар",
    catGamesSub: "Марафон, Time Attack, Duel",
    catKnowledge: "Назарий билимлар",
    catKnowledgeSub: "Белгилар ва йўл қоидалари",
    catShpargalka: "Шпаргалка",
    catShpargalkaSub: "Тезликлар, масофалар, ўлчамлар",
    catSchools: "Ўқув жойлар",
    catSchoolsSub: "Яндекс харитада автомактаблар",
    catAI: "Устоз AI",
    catAISub: "Сунъий интеллект ёрдамчи",
    catContacts: "Алоқа ва каналлар",
    catContactsSub: "Телеграм, таклиф, шикоятлар",
    catTeachers: "Усtozлар",
    catTeachersSub: "Тажрибали мураббийлар",
    navHome: "Бош сахифа",
    navTopicsShort: "Мавзулар",
    sectionTests: "Тестлар",
    sectionLearn: "Ўрганиш",
    sectionCommunity: "Хамжамият",
    numberTests: "Сонли тестлар",
    numberTestsSub: "Саволлар сони билан",
    complexTests: "Мураккаб тестлар",
    complexTestsSub: "Қийин саволлар тўплами",
    savedTests: "Сақланган тестлар",
    savedTestsSub: "Кейинроқ ечиш учун",
    explainedTests: "Изохли тестлар",
    explainedTestsSub: "Хар бир саволга аудио изох — хатоларингизни тушуниб ечинг",
    tryIt: "Синаб кўриш",
    adminPanel: "Админ панел",
    myGroups: "Гурухларим",
    myGroupsSub: "Ўқувчиларни бошқариш",
    controlExamShort: "Назорат",
    testsByTopicsShort: "Мавзулар",
    myWrongQuestionsShort: "Хатоларим",
    catKnowledgeShort: "Билимлар",
    catVideosShort: "Дарсликлар",
    customTestsShort: "Созламали",
    numberTestsShort: "Сонли",
    complexTestsShort: "Мураккаб",
    savedTestsShort: "Сақланган",
    testsSubtitle: "Билимингизни синаб кўринг",
    realExamSub: "Имтиҳондаги форматда",
    nazoratSub: "Назорат имтиҳони режими",
    topicsSub: "Мавзулар бўйича",
    customSub: "Ўзингиз созланг",
    ticketsSub: "Билет вариантлари",
    mistakesSub: "Хато жавоб берган саволлар",
    gamesSubtitle: "Қизиқарли режимларда машқ қилинг",
    marathonSub: "Чексиз саволлар, 3 та ҳаёт",
    timeAttackSub: "Вақтга қарши яриш",
    duelSub: "Реал рақиб билан кураш",
    signsSub: "Йўл ҳаракати белгилари",
    pdfBook: "PDF китоб",
    login: "Кириш",
    register: "Рўйхатдан ўтиш",
    authSubtitle: "Ҳайдовчилик имтиҳонига тайёрланиш",
    authRegisterSubtitle: "Янги ҳисоб яратинг",
    namePlaceholder: "Исмингиз",
    emailOrUsername: "Email ёки Username",
    password: "Парол",
    confirmPassword: "Паролни тасдиқланг",
    loadingText: "Юкланмоқда...",
    or: "ёки",
    googleLogin: "Google билан кириш",
    noAccount: "Ҳисобингиз йўқми?",
    hasAccount: "Ҳисобингиз борми?",
    passwordMismatch: "Паролlar мос келмади!",
    errorOccurred: "Хатолик юз берди",
    friendDuelPlay: "Дўст билан ўйнаш",
    friendDuelSub: "Дўстингизни чақиринг ва беллашинг",
    loading: "Юкланмоқда...",
    cancel: "Бекор қилиш",
    notificationsPageTitle: "Билдиришномалар",
    videosPageTitle: "Амалиёт дарсликлари",
    catVideos: "Амалиёт дарсликлари",
    catVideosSub: "Видео дарсликлар орқали машқ қилинг",
    noNotifications: "Ҳозирча билдиришномалар йўқ",
    noVideos: "Ҳозирча видеолар йўқ",
    reportQuestion: "Савол бўйича шикоят",
    reportWrongAnswer: "Тест жавоби хато",
    reportTypo: "Имловий хато",
    reportComment: "Изоҳ",
    reportCommentPlaceholder: "Фикрингизни ёзинг (ихтиёрий)...",
    reportSubmit: "Юбориш",
    reportSuccess: "Шикоятингиз қабул қилинди",
    reportError: "Шикоят юборишда хатолик",
    reportSelectType: "Камида битта турни танланг",
    statistics: "Статистика",
    recentTests: "Сўнгги тестлар",
    totalTests: "Жами тест",
    avgScore: "Ўртача балл",
    correctAnswers: "Тўғри жавоб",
    wrongAnswers: "Хато жавоб",
    favoritesCount: "Севимлилар",
    duelStats: "Дуэль статистикаси",
    wins: "Ғалаба",
    losses: "Мағлубият",
    draws: "Дуранг",
    totalGames: "Жами ўйин",
    dangerZone: "Хавфли зона",
    clearHistory: "Тарихни тозалаш",
    clearHistoryDesc:
      "Бутун тест тарихингиз ва статистикангиз ўчирилади. Бу амални бекор қилиб бўлмайди.",
    clearHistoryConfirm:
      "Бутун тест тарихингиз ва статистикангиз ўчирилади. Бу амални бекор қилиб бўлмайди. Давом этасизми?",
    clearHistorySuccess: "Тарих муваффақиятли тозаланди",
  },

  ru: {
    readiness: "Готовность к экзамену",
    readyForExam: "🎉 Готов к экзамену!",
    keepGoing: "💪 Хорошо идёт, продолжайте!",
    practiceMore: "📚 Нужно больше практики!",
    noMistakes: "Отлично! 🎉",
    noMistakesDesc: "У вас пока нет ошибочных вопросов!",
    noTypedQuestions: "Пока нет 🚧",
    noTypedQuestionsDesc:
      "Вопросы этого типа ещё не добавлены. Скоро появятся!",
    backToMenu: "Вернуться в меню",
    questionsCount: "{n} вопросов",
    fullName: "Полное имя",
    email: "Email",
    save: "Сохранить",
    language: "Язык",
    notifications: "Уведомления",
    dailyReminder: "Ежедневные напоминания",
    appName: "Avto Mind",
    todayPractice: "Тренируйся и сегодня!",
    wrongQuestions: "Ошибочные вопросы",
    ticketsSolved: "Билеты решены",
    topicsSolved: "Темы пройдены",
    testsByTopics: "Тесты по темам",
    customTests: "Настраиваемые тесты",
    tickets: "Билеты",
    marathon: "Марафон",
    myWrongQuestions: "Мои ошибочные вопросы",
    signs: "Знаки",
    controlExam: "Контрольный экзамен",
    realExam: "Реальный экзамен",
    profile: "Профиль",
    settings: "Настройки",
    logout: "Выйти",

    user: "Пользователь",
    // ru
    quizMarathonFinished: "Марафон завершён",
    quizCongrats: "Поздравляем!",
    quizTryAgain: "Попробуйте снова",
    quizFinishUpper: "ЗАВЕРШИТЬ",
    quizFinish: "Завершить",
    quizNext: "Далее",
    quizPrevious: "Назад",
    back: "Назад",
    randomTest: "Случайный тест",
    chooseAmountAndStart: "Выберите количество и начните",
    startRandom: "Начать случайный тест",
    randomInfo:
      "Выбранное количество вопросов будет случайным образом выбрано из всех тем.",
    question: "Вопрос",
    telegramChannel: "Телеграм",
    feedback: "Предложения и жалобы",
    trafficRules: "Книга правил дорожного движения (PDF)",
    badgeTop: "ТОП",
    badgeNew: "NEW",
    badgeSoon: "СКОРО",
    catTests: "Теория и тесты",
    catTestsSub: "Реальный экзамен, билеты, темы",
    catGames: "Игры",
    catGamesSub: "Марафон, Time Attack, Дуэль",
    catKnowledge: "Теоретические знания",
    catKnowledgeSub: "Знаки и правила дорожного движения",
    catShpargalka: "Шпаргалка",
    catShpargalkaSub: "Скорости, дистанции, габариты",
    catSchools: "Автошколы",
    catSchoolsSub: "Автошколы на карте Яндекс",
    catAI: "Наставник AI",
    catAISub: "Помощник на базе ИИ",
    catContacts: "Связь и каналы",
    catContactsSub: "Телеграм, предложения, жалобы",
    catTeachers: "Инструкторы",
    catTeachersSub: "Опытные инструкторы",
    navHome: "Главная",
    navTopicsShort: "Темы",
    sectionTests: "Тесты",
    sectionLearn: "Обучение",
    sectionCommunity: "Сообщество",
    numberTests: "Тесты по количеству",
    numberTestsSub: "По количеству вопросов",
    complexTests: "Сложные тесты",
    complexTestsSub: "Подборка трудных вопросов",
    savedTests: "Сохранённые тесты",
    savedTestsSub: "Чтобы решить позже",
    explainedTests: "Тесты с объяснением",
    explainedTestsSub: "Аудио-объяснение к каждому вопросу — разберитесь в своих ошибках",
    tryIt: "Попробовать",
    adminPanel: "Админ-панель",
    myGroups: "Мои группы",
    myGroupsSub: "Управление учениками",
    controlExamShort: "Контроль",
    testsByTopicsShort: "Темы",
    myWrongQuestionsShort: "Мои ошибки",
    catKnowledgeShort: "Знания",
    catVideosShort: "Уроки",
    customTestsShort: "Настройка",
    numberTestsShort: "По числу",
    complexTestsShort: "Сложные",
    savedTestsShort: "Сохранённые",
    testsSubtitle: "Проверьте свои знания",
    realExamSub: "В формате реального экзамена",
    nazoratSub: "Режим контрольного экзамена",
    topicsSub: "По темам",
    customSub: "Настройте сами",
    ticketsSub: "Варианты билетов",
    mistakesSub: "Вопросы с ошибками",
    gamesSubtitle: "Тренируйтесь в интересных режимах",
    marathonSub: "Бесконечные вопросы, 3 жизни",
    timeAttackSub: "Гонка против времени",
    duelSub: "Соревнование с реальным соперником",
    signsSub: "Знаки дорожного движения",
    pdfBook: "Книга PDF",
    login: "Войти",
    register: "Регистрация",
    authSubtitle: "Подготовка к экзамену по вождению",
    authRegisterSubtitle: "Создайте новый аккаунт",
    namePlaceholder: "Ваше имя",
    emailOrUsername: "Email или имя пользователя",
    password: "Пароль",
    confirmPassword: "Подтвердите пароль",
    loadingText: "Загрузка...",
    or: "или",
    googleLogin: "Войти через Google",
    noAccount: "Нет аккаунта?",
    hasAccount: "Уже есть аккаунт?",
    passwordMismatch: "Пароли не совпадают!",
    errorOccurred: "Произошла ошибка",
    friendDuelPlay: "Играть с другом",
    friendDuelSub: "Пригласите друга и соревнуйтесь",
    loading: "Загрузка...",
    cancel: "Отмена",
    notificationsPageTitle: "Уведомления",
    videosPageTitle: "Практические уроки",
    catVideos: "Практические уроки",
    catVideosSub: "Практикуйтесь с видеоуроками",
    noNotifications: "Пока нет уведомлений",
    noVideos: "Пока нет видео",
    reportQuestion: "Пожаловаться на вопрос",
    reportWrongAnswer: "Неверный ответ",
    reportTypo: "Опечатка",
    reportComment: "Комментарий",
    reportCommentPlaceholder: "Напишите комментарий (необязательно)...",
    reportSubmit: "Отправить",
    reportSuccess: "Ваша жалоба принята",
    reportError: "Ошибка при отправке жалобы",
    reportSelectType: "Выберите хотя бы один тип",
    statistics: "Статистика",
    recentTests: "Последние тесты",
    totalTests: "Всего тестов",
    avgScore: "Средний балл",
    correctAnswers: "Правильные ответы",
    wrongAnswers: "Неправильные ответы",
    favoritesCount: "Избранное",
    duelStats: "Статистика дуэлей",
    wins: "Победы",
    losses: "Поражения",
    draws: "Ничьи",
    totalGames: "Всего игр",
    dangerZone: "Опасная зона",
    clearHistory: "Очистить историю",
    clearHistoryDesc:
      "Вся история тестов и статистика будут удалены. Это действие необратимо.",
    clearHistoryConfirm:
      "Вся история тестов и статистика будут удалены. Это действие необратимо. Продолжить?",
    clearHistorySuccess: "История успешно очищена",
  },
};

export function format(s: string, vars?: Record<string, string | number>) {
  if (!vars) return s;
  return s.replace(/\{(\w+)\}/g, (_, k) => String(vars[k] ?? `{${k}}`));
}
